import { getIntegrationCategoryDisplayNameByServiceId } from '../../common/integrations'

export interface UpToDateProps {
  serviceId: string
}

export const UpToDate: React.FC<UpToDateProps> = ({ serviceId }) => {
  const integrationTypeDisplayName = getIntegrationCategoryDisplayNameByServiceId(serviceId)

  return <div className='d-flex align-items-center justify-content-center label-large'>Your {integrationTypeDisplayName} is up to date!</div>
}
